<template>
  <router-link class="button" to="/stratslist/create">Create</router-link>
</template>